export default __webpack_public_path__ + "static/media/signUpLogo.0440b175.png";